import { useQueryClient } from '@tanstack/react-query';

import { useSetNotification } from '../../../../../context/Notification';
import { DrChronoTask } from '../types';
import { DRCHRONO_TASKS_KEY } from './constants';

/** Success handling shared by task create and update. */
const useOnTaskSaved = (
    member_id: number | null | undefined,
    verb: 'created' | 'updated',
    onSuccess?: () => void
) => {
    const setNotification = useSetNotification();
    const queryClient = useQueryClient();

    return (task: DrChronoTask) => {
        // The task stands even when its note failed; rtm-api says so rather than erroring.
        setNotification(
            task.note_failed
                ? { message: `Task ${verb}, but the note could not be saved`, type: 'neutral' }
                : { message: `Task ${verb} in DrChrono`, icon: 'checkmark' }
        );
        queryClient.invalidateQueries({ queryKey: [DRCHRONO_TASKS_KEY, member_id] });
        onSuccess?.();
    };
};

export default useOnTaskSaved;
